<h2 class="mb-2 py-1">Your quote</h2>
<h3 *ngIf="!hideSubtitle">Your {{ isInsurance ? 'cover' : 'plan' }}</h3>
